import { Icon } from "@nexus/ui";

export type TableSortDirection = "asc" | "desc";

export function SortableColumnHeader<SortKey extends string>({
  label,
  sortBy,
  activeSortBy,
  sortDirection,
  defaultDirection = "asc",
  className,
  onChange,
}: {
  label: string;
  sortBy: SortKey;
  activeSortBy: SortKey;
  sortDirection: TableSortDirection;
  defaultDirection?: TableSortDirection;
  className?: string;
  onChange: (sortBy: SortKey, direction: TableSortDirection) => void;
}) {
  const active = activeSortBy === sortBy;
  const direction = active ? sortDirection : undefined;
  return (
    <span
      role="columnheader"
      aria-sort={
        direction === "asc"
          ? "ascending"
          : direction === "desc"
            ? "descending"
            : "none"
      }
      className={className}
    >
      <button
        type="button"
        className="inline-flex cursor-pointer items-center gap-1 rounded-sm outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring/40"
        onClick={() =>
          onChange(
            sortBy,
            active
              ? sortDirection === "asc"
                ? "desc"
                : "asc"
              : defaultDirection,
          )
        }
      >
        {label}
        {active ? (
          <Icon
            name={sortDirection === "asc" ? "arrow-up" : "arrow-down"}
            size="xs"
            color="inherit"
            aria-hidden
          />
        ) : null}
      </button>
    </span>
  );
}
